import TopBarContainer from 'app/viewport/components/TopBar/Container';

export default TopBarContainer;
